import OneNetworkConfig from '@/onenetwork/core/onenetwork.config.ts'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import PushCampaignList from '@/modules/push-campaign/views/PushCampaignList.vue'
import PushCampaignDetailPage from '@/modules/push-campaign/views/PushCampaignDetailPage.vue'

const baseRoute = OneNetworkConfig.baseRoutePath
const pushCampaignRouter = [
  {
    path: `${baseRoute}/push-campaign/list`,
    name: 'push-campaign-list',
    meta: {
      component: PushCampaignList
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/push-campaign/list/create`,
    name: 'push-campaign-list-create',
    meta: {
      component: PushCampaignDetailPage,
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/push-campaign/detail/:id`,
    name: 'push-campaign-detail',
    meta: {
      component: PushCampaignDetailPage,
    },
    component: PrivateRouter,
  },
]
export default pushCampaignRouter
